module.exports = __webpack_public_path__ + "img/bombero_down_selected.80989718.svg";